import { t } from '@lingui/macro'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

export function RegionPicker({ value, onChange, label = t`AWS Region`, disabled = false, required = false }) {
    // Define AWS_REGIONS inside the function
    const AWS_REGIONS = [
        { label: t`US East (N. Virginia)`, value: 'us-east-1' },
        { label: t`US East (Ohio)`, value: 'us-east-2' },
        { label: t`US West (N. California)`, value: 'us-west-1' },
        { label: t`US West (Oregon)`, value: 'us-west-2' },
        { label: t`Africa (Cape Town)`, value: 'af-south-1' },
        { label: t`Asia Pacific (Hong Kong)`, value: 'ap-east-1' },
        { label: t`Asia Pacific (Hyderabad)`, value: 'ap-south-2' },
        { label: t`Asia Pacific (Jakarta)`, value: 'ap-southeast-3' },
        { label: t`Asia Pacific (Malaysia)`, value: 'ap-southeast-5' },
        { label: t`Asia Pacific (Melbourne)`, value: 'ap-southeast-4' },
        { label: t`Asia Pacific (Mumbai)`, value: 'ap-south-1' },
        { label: t`Asia Pacific (Osaka)`, value: 'ap-northeast-3' },
        { label: t`Asia Pacific (Seoul)`, value: 'ap-northeast-2' },
        { label: t`Asia Pacific (Singapore)`, value: 'ap-southeast-1' },
        { label: t`Asia Pacific (Sydney)`, value: 'ap-southeast-2' },
        { label: t`Asia Pacific (Taipei)`, value: 'ap-east-2' },
        { label: t`Asia Pacific (Thailand)`, value: 'ap-southeast-7' },
        { label: t`Asia Pacific (Tokyo)`, value: 'ap-northeast-1' },
        { label: t`Canada (Central)`, value: 'ca-central-1' },
        { label: t`Canada West (Calgary)`, value: 'ca-west-1' },
        { label: t`Europe (Frankfurt)`, value: 'eu-central-1' },
        { label: t`Europe (Ireland)`, value: 'eu-west-1' },
        { label: t`Europe (London)`, value: 'eu-west-2' },
        { label: t`Europe (Milan)`, value: 'eu-south-1' },
        { label: t`Europe (Paris)`, value: 'eu-west-3' },
        { label: t`Europe (Spain)`, value: 'eu-south-2' },
        { label: t`Europe (Stockholm)`, value: 'eu-north-1' },
        { label: t`Europe (Zurich)`, value: 'eu-central-2' },
        { label: t`Israel (Tel Aviv)`, value: 'il-central-1' },
        { label: t`Mexico (Central)`, value: 'mx-central-1' },
        { label: t`Middle East (Bahrain)`, value: 'me-south-1' },
        { label: t`Middle East (UAE)`, value: 'me-central-1' },
        { label: t`South America (São Paulo)`, value: 'sa-east-1' },
        { label: t`AWS GovCloud (US-East)`, value: 'us-gov-east-1' },
        { label: t`AWS GovCloud (US-West)`, value: 'us-gov-west-1' }
    ]

    return (
        <FormControl fullWidth required={required} disabled={disabled}>
            <InputLabel>{label}</InputLabel>
            <Select value={value} label={label} onChange={onChange}>
                {AWS_REGIONS.map((region) => (
                    <MenuItem key={region.value} value={region.value}>
                        {region.label} ({region.value})
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
